export class AuthorizationConfig {
    previlege: Array<any> = [];
    previlegeModule: any;
  }
